var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalTapsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M37 0C49.7025 0 60 10.2975 60 23V37C60 49.7025 49.7025 60 37 60H23C10.2975 60 0 49.7025 0 37V23C0 10.2975 10.2975 0 23 0H37Z",
    fill: "#00614B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M37.999 24.667C40.2082 24.667 41.999 26.4579 41.999 28.667C41.9988 30.876 40.2081 32.667 37.999 32.667C35.7901 32.6668 33.9992 30.8759 33.999 28.667C33.999 26.458 35.79 24.6672 37.999 24.667ZM25.999 18C28.9444 18 31.3328 20.3876 31.333 23.333C31.333 26.2785 28.9445 28.667 25.999 28.667C23.0537 28.6668 20.666 26.2784 20.666 23.333C20.6662 20.3877 23.0538 18.0002 25.999 18Z",
    fill: "#00614B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9774 31.333C32.3611 31.333 37.6061 34.3905 37.997 40.9326C38.0125 41.1932 37.9966 42 36.995 42H14.9696C14.6351 41.9996 13.9727 41.2782 14.0009 40.9316C14.5178 34.5683 19.6824 31.3331 25.9774 31.333ZM37.4696 34.002C42.011 34.0521 45.7189 36.3476 45.9979 41.2002C46.0091 41.3961 45.9973 41.9996 45.2753 42H40.1337C40.1336 38.9995 39.1423 36.2299 37.4696 34.002Z",
    fill: "#00614B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTapsIcon);
export default __webpack_public_path__ + "static/media/total-taps-icon.bd221bc981b9fad4c4220aaffc12c57a.svg";
export { ForwardRef as ReactComponent };